import { Box, CircularProgress, Stack, Typography } from "@mui/material";
import SettingIcon from "src/assets/svg-icons/side-bar/settings.svg";
import RightArrow from "src/assets/svg-icons/aggregators/right_arrow.svg";
import InfoItem from "./info-item";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import TransactionItemsTable from "./items-table";
import { useGetItemsSalesById } from "src/api/add-sales";

const RecipeCostSalesDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { t } = useTranslation("inventory");
  const { t: salesT } = useTranslation("addSales");
  const { t: generalT } = useTranslation("general");

  const { data, isLoading } = useGetItemsSalesById(id || "");

  const navigateToInventory = () => {
    navigate("/inventory");
  };

  const navigateToCogs = () => {
    navigate(`/inventory/cogs`);
  };

  return (
    <Stack gap={3} p={{ xs: 2, sm: 4 }}>
      <Stack
        direction={"row"}
        spacing={"12px"}
        alignItems={"center"}
        color={"#101828"}
      >
        <Box
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          width={"60px"}
          height={"60px"}
          bgcolor={"#D0D5DD"}
          borderRadius={"16px"}
        >
          <img src={SettingIcon} width={"32px"} alt="" />
        </Box>
        <Typography fontSize={"32px"} lineHeight={"38.4px"}>
          {generalT("inventory")}
        </Typography>
      </Stack>
      {/* divider */}
      <Box bgcolor={"#F2F4F7"} width={"100%"} height={"1px"} />

      <Stack spacing={2} direction={"row"} alignItems={"center"}>
        <Typography
          color={"#475467"}
          lineHeight={"19.2px"}
          onClick={navigateToInventory}
          sx={{ cursor: "pointer" }}
        >
          {generalT("inventory")}
        </Typography>
        <img src={RightArrow} alt="" />
        <Typography
          color={"#475467"}
          lineHeight={"19.2px"}
          sx={{ cursor: "pointer" }}
          onClick={navigateToCogs}
        >
          {generalT("cogs")}
        </Typography>
        <img src={RightArrow} alt="" />
        <Box borderRadius={"4px"} bgcolor={"#EAECF0"} p={"4px 8px"}>
          <Typography color={"#344054"} fontWeight={600} lineHeight={"19.2px"}>
            {data?.data.reference}
          </Typography>
        </Box>
      </Stack>
      {isLoading && !data ? (
        <Box display={"flex"} justifyContent={"center"} pt={20}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          <Stack bgcolor={"#F9FAFB"} spacing={1.5} p={2}>
            <InfoItem
              title={generalT("branch")}
              text={`${data?.data.branch_name || ""}`}
              label={generalT("createdAt")}
              value={`${data?.data.created_at ?? ""}`}
            />

            <InfoItem
              title={t("total")}
              text={`${data?.data.total}`}
              label={""}
              value={""}
            />
          </Stack>
          <TransactionItemsTable
            list={data.data.item_sales}
            isLoading={isLoading}
          />
        </>
      )}
    </Stack>
  );
};

export default RecipeCostSalesDetails;
